

import {configureStore} from "@reduxjs/toolkit"
import {userMgmtSlice} from "./Reducers/userMgmtSlice"


export const store=configureStore({
    reducer: {
        usermgmtData: userMgmtSlice.reducer,
        // dashboardData:dashboardSlice.reducer,
        // varificationData: verificationSlice.reducer,
        // cityData: citySlice.reducer,
        // categoryData: categorySlice.reducer,
        // productData: productSlice.reducer
      },
})